export default __webpack_public_path__ + "static/media/edit-location.1bf3b08c.svg";